export default "__VITE_ASSET__b4fc853c__"